import React, { useEffect, useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import DynamicTable from "../DynamicTable/DynamicTable";
import { Box, IconButton } from "@mui/material";
import { CSVLink } from "react-csv";
import pdfImage from "../../images/pdf-image.svg"
import csvImage from "../../images/excel-image.svg"
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useSelector } from "react-redux";

export default function UserReportTable({
  usersData,
  handleSelectedUser,
  targetID,
  systemRoles,
  userStatus,
  startDate,
  endDate
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const pageCount = Math.ceil(usersData.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  const [usersTable, setUsersTable] = useState(null);
  const [filteredRecords, setFilteredRecords] = useState([]);

  let configVariables = useSelector((state) => state.config.baseConfig);
  var columnsToHide = configVariables.onboardingReportColumnsToHide;
  
  // console.log(pageCount, pageNumbers)

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  console.log("usersData=============",usersData);

  async function getTable() {
    let response = await fetch(`/tables/userReportTable.json`);
    // let response = await fetch(`/tables/operatorTable.json`);
    const tableData = await response.json();
    console.log("tableDataaaaa==========",tableData);

    console.log("columnsToHide==========", columnsToHide);
    // const fieldsToRemove = columnsToHide.split(",").map(item => item.trim().toLowerCase());
    const fieldsToRemove = (columnsToHide || "").split(",").map(item => item.trim().toLowerCase()).filter(Boolean);
    
    // Filter columns
    const updatedColumns = tableData?.columns?.filter(column => {
      // Some sources are arrays stored as strings like ["firstName", "lastName"]
      try {
        const parsedSource = JSON.parse(column.source);

        if (Array.isArray(parsedSource)) {
          return !parsedSource.some(src =>
            fieldsToRemove.includes(src.toLowerCase())
          );
        }
      } catch {
        // Not a JSON array, treat as normal string
      }
      
      return !fieldsToRemove.includes(column.source.toLowerCase());
    });

    const updatedTableData = {
      ...tableData,
      columns: updatedColumns
    };
    console.log("updatedTableData==========", updatedTableData);

    setUsersTable(updatedTableData);
    setRowsPerPage(updatedTableData.rowsPerPage);

    // console.log("usersData==========",usersData);
    // setUsersTable(tableData);
    // setRowsPerPage(tableData.rowsPerPage);
  }

  useEffect(() => {
    getTable();
  }, []);

  const runPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4"
    });

    const formatDate = (dateStr) => new Date(dateStr).toISOString().slice(0, 10);
    const dateRange = `(${formatDate(startDate)} to ${formatDate(endDate)})`;
  
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    // doc.text("User OFAC Report", 14, 15);
    doc.text(`User Onboarding Report ${dateRange}`, 14, 15);
  
    // Define headers and body
    const headers = [
      "Date Added",
      "User Id",
      "Name",
      "Email",
      "KYC Policy Id",
      "KYC Status",
      "OFAC Score",
      "OFAC Run Date",
      "Purpose Of Account",
      "Merchant Name"
    ];
  
    const body = flatUsers.map(user => [
      user.dateAdded,
      user.id,
      `${user.firstName} ${user.lastName}`,
      user.emailAccount,
      user.kycpolicyid,
      user.profilestatus_label,
      user.ofac_score,
      user.ofac_requesttime,
      user.purposeofaccount,
      `${user.brokerFirstName} ${user.brokerLastName}`
    ]);
  
    // Call autoTable with the doc
    autoTable(doc, {
      head: [headers],
      body: body,
      startY: 20,
      theme: "striped",
      styles: {
        fontSize: 10,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [108, 117, 125] // Bootstrap secondary gray
      }
    });
  
    doc.save(`Onboarding-Report-${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  const flatUsers = usersData.map(user => user.UserNew);
  const csvData = flatUsers.map(user => ({
    "Date Added": user.dateAdded,
    "User Id": user.id,
    "Name": `${user.firstName} ${user.lastName}`,
    "Email": user.emailAccount,
    "KYC Policy Id": user.kycpolicyid,
    "KYC Status": user.profilestatus_label,
    "OFAC Score": user.ofac_score == "-0" ? "0" : user.ofac_score,
    "OFAC Run Date": user.ofac_requesttime,
    "Purpose Of Account": user.purposeofaccount,
    "Merchant Name": `${user.brokerFirstName} ${user.brokerLastName}`
  }));

  return (
    <>
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Box
          className="text-end"
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "right",
              marginLeft: "auto",
            }}
          >
            <CSVLink
              data={csvData}
              filename={`PAiY-Test-${new Date().toISOString().slice(0, 10)}.csv`}
              style={{ textDecoration: "none" }}
            >
              <IconButton
                sx={{
                  width: 40,
                  height: 40,
                  color: "#6c757d",
                  backgroundColor: "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(108, 117, 125, 0.1)",
                  },
                }}
              >
                <img src={csvImage} alt="CSV" loading="lazy" />
              </IconButton>
            </CSVLink>

            {/* PDF Button */}
            <IconButton
              onClick={runPDF}
              sx={{
                width: 40,
                height: 40,
                color: "#6c757d",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "rgba(108, 117, 125, 0.1)",
                },
              }}
            >
              <img src={pdfImage} alt="PDF" loading="lazy" />
            </IconButton>
          </Box>
        </Box>
        {usersTable && (
          <DynamicTable
            tableData={usersData}
            tableSource={usersTable}
            page={page}
            handleEdit={handleSelectedUser}
            targetID={targetID}
            twoColumn={false}
            roles={systemRoles}
            userStatus={userStatus}
          />
        )}
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>
    </>
  );
}
